import React, { useMemo } from 'react';
import NavigationStepper, {
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepperItems from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepperItems';
import { WorkplaceMembersView } from '../../Enums/WorkplaceMembersView.enum';
import styles from './EArchiveGroupWrapper.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import EArchiveGroup from './EArchiveGroup';

interface Props {
	groupId: string;
	isSystemGroup: boolean;
	groupType?: string;
	onDelete: () => void;
	closeDetail: () => void;
}

const EArchiveGroupWrapper = ({
	groupId,
	isSystemGroup,
	groupType,
	onDelete,
	closeDetail,
}: Props) => {
	const steps: NavigationStepperItemType[] = useMemo(() => {
		const items: NavigationStepperItemType[] = [
			{
				name: 'component.eArchive.group.members.title',
				key: 'members',
				component: () => (
					<EArchiveGroup
						view={WorkplaceMembersView.MEMBERS}
						groupId={groupId}
						isSystemGroup={isSystemGroup}
						groupType={groupType}
						onDelete={onDelete}
					/>
				),
			},
		];

		if (!isSystemGroup) {
			items.push({
				name: 'component.eArchive.group.settings.title',
				key: 'settings',
				component: () => (
					<EArchiveGroup
						view={WorkplaceMembersView.SETTINGS}
						groupId={groupId}
						isSystemGroup={isSystemGroup}
						groupType={groupType}
						onDelete={onDelete}
					/>
				),
			});
		}

		items.push({
			name: 'component.eArchive.group.actions.title',
			key: 'actions',
			component: () => (
				<EArchiveGroup
					view={WorkplaceMembersView.ACTIONS}
					groupId={groupId}
					onDelete={onDelete}
				/>
			),
		});

		return items;
	}, [groupId, onDelete, isSystemGroup, groupType]);

	return (
		<div className={styles.wrapper}>
			<NavigationStepper
				steps={steps}
				initialStepPath={'members'}
				canSkip
				renderItems={({ items, activeKey, onChange }) => (
					<SubTabNavigationStepperItems
						items={items}
						activeKey={activeKey}
						onChange={onChange}
					/>
				)}
			/>
			<LinkButton
				className={styles.closeButton}
				title={'base.shared.close'}
				onClick={closeDetail}
				theme={Theme.RED}
			/>
		</div>
	);
};

export default EArchiveGroupWrapper;
